import { createReducer } from '@reduxjs/toolkit'

import { Field, resetMintState, setDeadline, setSlippageTolerance, switchFields, typeInput } from './actions'

export interface MintCharmState {
  readonly independentField: Field
  readonly typedValue: string
  readonly otherTypedValue: string // for the case when there's no liquidity
  readonly slippageTolerance: number // percentage (0-100) for amount0Min/amount1Min calculation
  readonly deadline: number // transaction deadline in minutes
}

export const initialState: MintCharmState = {
  independentField: Field.CURRENCY_A,
  typedValue: '',
  otherTypedValue: '',
  slippageTolerance: 0.5, // 0.5% default slippage
  deadline: 20, // 20 minutes default deadline
}

export default createReducer<MintCharmState>(initialState, (builder) =>
  builder
    .addCase(resetMintState, () => initialState)
    .addCase(switchFields, (state, { payload: { independentField, typedValue, otherTypedValue } }) => {
      return {
        ...state,
        independentField: independentField === Field.CURRENCY_A ? Field.CURRENCY_B : Field.CURRENCY_A,
        typedValue: otherTypedValue,
        otherTypedValue: typedValue,
      }
    })
    .addCase(typeInput, (state, { payload: { field, typedValue, noLiquidity } }) => {
      if (noLiquidity) {
        if (field === state.independentField) {
          return {
            ...state,
            independentField: field,
            typedValue,
          }
        } else {
          return {
            ...state,
            independentField: field,
            typedValue,
            otherTypedValue: state.typedValue,
          }
        }
      } else {
        return {
          ...state,
          independentField: field,
          typedValue,
          otherTypedValue: '',
        }
      }
    })
    .addCase(setSlippageTolerance, (state, { payload: { slippageTolerance } }) => {
      return {
        ...state,
        slippageTolerance,
      }
    })
    .addCase(setDeadline, (state, { payload: { deadline } }) => {
      return {
        ...state,
        deadline,
      }
    })
)
